import React from 'react'
import { Skeleton } from '@material-ui/lab'

const LoaderStackedBar = () => {
  return (
    <div className="space-y-52 px-5 py-10">
      <Skeleton
        variant="rect"
        width="full"
        height={20}
        className="rounded-lg"
      />
      <Skeleton
        variant="rect"
        width="full"
        height={20}
        className="rounded-lg"
      />
      <Skeleton
        variant="rect"
        width="full"
        height={20}
        className="rounded-lg"
      />
      <Skeleton
        variant="rect"
        width="full"
        height={20}
        className="rounded-lg"
      />
    </div>
  )
}

export default LoaderStackedBar
